/* Copyright (C) mroads, LLC - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Written by Snigdha <snigdha.dhanireddy@mroads.com>, August 2020
 * @format
 * @flow
 */

export default {
    getStoreInfo: 'api/serverApp/storeInfo/deviceId/',
    activateDevice: 'api/serverApp/activate',
    reactivateDevice: 'api/serverApp/reActivate',
    updateSyncStatus: '/api/serverApp/deviceStatus/update',
    getCheckForFireboard: 'api/serverApp/fireBoard/checks',
    getFutureOrders: '/api/serverApp/fireBoard/futureOrderDetail',
    futureOrdersList: '/api/serverApp/fireBoard/futureOrderSummary',
    disableOrders: 'api/serverApp/fireBoard/channelStatus',
    updatePrepTime: '/api/serverApp/fireBoard/prepWindow/update',
    updateProdTime: '/api/serverApp/fireBoard/productionRate/update',
    payNow: 'api/serverApp/fireBoard/payNow',
    getMemberDetails: 'api/serverApp/member/memberId/{memberId}',
    checkInRequest: 'api/serverApp/fireBoard/textToCheckIn',
    generateTextToPay: 'api/serverApp/fireBoard/textToPay',
    acknowledgeIdCheck: 'api/serverApp/notifications/acknowledge',
    acknowledgeOverServe: 'api/serverApp/notifications/acknowledge',
    acknowledgeNotification: 'api/serverApp/notifications/acknowledge',

    pingOneDine: 'api/serverApp/pingOneDine/deviceId/',

    searchItemStock: '/api/serverApp/menuItem/search',
    searchModifierStock: '/api/serverApp/modifier/search',
    getOutOfStockItemList: '/api/serverApp/menuItem/outOfStock/list',
    getOutOfStockModifierList: '/api/serverApp/modifier/outOfStock/list',
    updateItemStock: '/api/serverApp/menuItem/outOfStock/update',
    updateModifierStock: '/api/serverApp/modifier/outOfStock/update',

    reservationAPI: 'api/serverApp/tms/',

    login: 'api/serverApp/login',
    pairWatch: 'api/serverApp/autoActivate',
    seatTable: 'api/serverApp/tms/booking/seatTable',

    orderStatusUpdate: 'api/serverApp/order/updateStatus',

    tableReceiptPrint: 'api/serverApp/tableReceipt/print',
    fireboardSendSMS: 'api/serverApp/fireBoard/sendSms',
    orderStatusPaid: 'api/serverApp/order/updatePaid',
    syncCheck: 'api/serverApp/check/sync/checkHeaderId/',
    printItems: 'api/serverApp/label/print',
    printCheck: 'api/serverApp/label/print',

    preAuthCompleteFB: 'api/serverApp/management/preAuthComplete',
    stationGroup: 'api/serverApp/tms/stationGroup/storeId/',
    storeLayout: 'api/serverApp/tms/storeLayout/storeId/',
    getPrintOrderTicket: 'api/serverApp/orderTicket/print',
    updateStoreLayout: 'api/serverApp/tms/storeLayout/update',
    getVenueInfo: 'api/serverApp/venueInfo/deviceId/',
    sensorCode: 'api/serverApp/fireBoard/station/sensor',
    cashPayment: 'api/serverApp/payment/cashInit',
    initializePayment: 'api/serverApp/payment/init',
    paymentIngenicoComplete: 'api/serverApp/payment/complete',

    validateGiftCard: 'api/serverApp/loyalty/giftCard/validate',
    paymentGiftCardInit: 'api/serverApp/payment/giftCardInit',
    paymentGiftCardComplete: 'api/serverApp/payment/giftCardComplete',

    getStoreJobs: 'api/serverApp/jobs/storeId/',

    emailReceipt: 'api/serverApp/ticketReceipt/email',
    smsReceipt: 'api/serverApp/ticketReceipt/sms',
    receiptPrint: 'api/serverApp/ticketReceipt/print',
    getTips: 'api/serverApp/employee/tips',
    getMergedTables: 'api/serverApp/station/merges',
    mergeTable: 'api/serverApp/station/merge',
    unMergeTable: 'api/serverApp/station/unMerge',
    getStationEmployees: 'api/serverApp/station/employees',
    assignEmployee: 'api/serverApp/station/employee/assign',
    removeEmployeeAssignment: 'api/serverApp/station/employee/unAssign',
    assignTable: 'api/serverApp/employee/station/assign',
    removeTableAssignment: 'api/serverApp/employee/station/unAssign',
    retryPOSPayment: 'api/serverApp/payment/rePostPos',
    customSmsTemplates: 'api/serverApp/fireBoard/customSmsTemplates/storeId/',
    sensors: 'api/serverApp/store/sensors/storeId/',
    updateSensorGroup: 'api/serverApp/fireBoard/sensorGroup/update',
    updateVenueOrder: 'api/serverApp/fireBoard/venueOrdering/update',
    updateFoodRunner: 'api/serverApp/fireBoard/foodRunner/update',
    deRegisterSensor: 'api/serverApp/sensor/deRegister/sensorId/',
    registerSensor: 'api/serverApp/sensor/register',
    namedSensor: 'api/serverApp/store/sensors/named/storeId/',
    voucherCheckIn: 'api/serverApp/voucher/checkIn',
    voucherSearch: 'api/serverApp/voucher/search',
    storeProductions: 'api/serverApp/store/production/storeId/',
    storeProductionOverride: 'api/serverApp/store/production/override',
    productionOverrideReasons: 'api/serverApp/productionOverrideReasons',
    cubbyAssign: 'api/serverApp/cubby/assign',
    orderPickedUp: 'api/serverApp/order/pickedUp',
    textToGetLocation: 'api/serverApp/fireBoard/textToGetLocation/checkHeaderId/',
    gpsLocationPickedUp: 'api/serverApp/gpsLocation/pickedUp',
    updateGuestInformation: 'api/serverApp/order/guestInfo/update',
    getChecks: 'api/cache/checksCompressed/storeId/',
    getVenueChecks: 'api/cache/checksCompressed/venueId/',
    getNotifications: 'api/cache/notificationsCompressed/storeId/',
    getBookings: 'api/cache/bookingsCompressed/storeId/',
    getSectionEmployee: 'api/serverApp/section/employees',
    assignSectionToEmployee: 'api/serverApp/employee/section/assign',
    assignEmployeeToSection: 'api/serverApp/section/employee/assign',
    unAssignSectionFromEmployee: 'api/serverApp/employee/section/unAssign',
    unAssignEmployeeFromSection: 'api/serverApp/section/employee/unAssign',
    renameSeat: 'api/serverApp/seat/rename',
    getStoreLayoutBySensorGroup: 'api/serverApp/tms/storeLayout/storeId/{storeId}/sensorGroupId/{sensorGroupId}',
    updateStoreLayoutBySensorGroup: 'api/serverApp/tms/storeLayout/sensorGroup/update',
    firePendingItems: 'api/serverApp/order/fire',
    ageVerification: 'api/serverApp/check/idCheck/confirm',
    ageRestrictedItemsUpdateForCheck: 'api/serverApp/check/ageRestrictedItems/update',
    ageRestrictedItemsUpdateForSeat: 'api/serverApp/seat/ageRestrictedItems/update',

    logToApiLog: 'api/admin/apiLog',
    bookingClear: 'api/serverApp/tms/waitList/clear',
    bookingCancel: 'api/serverApp/tms/waitList/cancel',
    bookingCreate: 'api/serverApp/tms/waitList/create',
    bookingUpdate: 'api/serverApp/tms/waitList/update',
    bookingComplete: 'api/serverApp/tms/waitList/complete',
    bookingMove: 'api/serverApp/tms/waitList/move',
    moveGuest: 'api/serverApp/check/transfer/station',
    syncIfModified: 'api/serverApp/check/syncIfModified',
    voidCheck: 'api/serverApp/check/void',
};
